/** @jsx jsx */
import React from 'react';
import { styled, css, jsx } from '@compiled/react';

import { AppSkeletonImage } from '@jira/platform__skeleton-image-container/src/ui/AppSkeletonImage.tsx';
// eslint-disable-next-line jira/import-whitelist
import UFOLoadHold from '@atlaskit/react-ufo/load-hold';
import objectViewAttributesSVG from './assets/insight-object-view-attributes-skeleton.tpl.svg';
import objectViewHeaderSVG from './assets/insight-object-view-header-skeleton.tpl.svg';
import objectViewLinkedObjectsSVG from './assets/insight-object-view-linked-objects-skeleton.tpl.svg';
import objectViewPanelSVG from './assets/insight-object-view-panel-skeleton.tpl.svg';
import objectViewSVG from './assets/insight-object-view-skeleton.tpl.svg';
import objectViewInObjectGraphSVG from './assets/insight-object-view-in-object-graph-skeleton.tpl.svg';

const skeletonCssStyles = css({
	// increase self specificity to ensure deterministic override
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
	'&&': {
		border: 'none',
	},
});

export const InsightObjectViewSkeleton = () => (
	<ObjectViewWrapper>
		<UFOLoadHold name="object-view-skeleton">
			<AppSkeletonImage src={objectViewSVG} css={skeletonCssStyles} />
		</UFOLoadHold>
	</ObjectViewWrapper>
);

export const InsightObjectViewInObjectGraphSkeleton = () => (
	<ObjectViewWrapper>
		<UFOLoadHold name="object-view-in-object-graph-skeleton">
			<AppSkeletonImage src={objectViewInObjectGraphSVG} css={skeletonCssStyles} />
		</UFOLoadHold>
	</ObjectViewWrapper>
);

export const InsightObjectViewHeaderSkeleton = () => (
	<HeaderWrapper>
		<UFOLoadHold name="object-view-header-skeleton">
			<AppSkeletonImage src={objectViewHeaderSVG} css={skeletonCssStyles} />
		</UFOLoadHold>
	</HeaderWrapper>
);

export const InsightObjectViewAttributesSkeleton = () => (
	<AttributesWrapper>
		<UFOLoadHold name="object-view-attributes-skeleton">
			<AppSkeletonImage src={objectViewAttributesSVG} css={skeletonCssStyles} />
		</UFOLoadHold>
	</AttributesWrapper>
);

export const InsightObjectViewLinkedObjectsSkeleton = () => (
	<LinkedObjectsWrapper>
		<UFOLoadHold name="object-view-linked-objects-skeleton">
			<AppSkeletonImage src={objectViewLinkedObjectsSVG} css={skeletonCssStyles} />
		</UFOLoadHold>
	</LinkedObjectsWrapper>
);

export const InsightObjectViewPanelSkeleton = () => (
	<PanelWrapper>
		<UFOLoadHold name="object-view-panel-skeleton">
			<AppSkeletonImage src={objectViewPanelSVG} css={skeletonCssStyles} />
		</UFOLoadHold>
	</PanelWrapper>
);

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const ObjectViewWrapper = styled.div({
	maxHeight: '613px',
	overflowY: 'hidden',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const HeaderWrapper = styled.div({
	maxHeight: '113px',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const AttributesWrapper = styled.div({
	maxHeight: '500px',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const LinkedObjectsWrapper = styled.div({
	maxHeight: '135px',
	overflowY: 'hidden',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const PanelWrapper = styled.div({
	maxHeight: '75px',
	overflowY: 'hidden',
});
